import { Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../../../../../lib/api";
import { toast } from "sonner";
import { Button } from "../../../../../../components/ui/button";
import { PriceCard } from "./PriceCard";

export default function PriceStep({
  setCurrentStep,
  selectedTeacher,
  selectedPrice,
  setSelectedPrice,
}) {
  const [prices, setPrices] = useState([]);
  const [loadingPrices, setLoadingPrices] = useState(true);
  const [priceError, setPriceError] = useState(null);


  const getPrices = async () => {
    try {
      const { data } = await axios.get(
        `${BaseUrlApi}/teacher/prices/${selectedTeacher.user.id}`
      );
      setPrices(data.data);
    } catch (error) {
      setPriceError("Failed to load pricing options. Please try again later.");
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setLoadingPrices(false);
    }
  };

  useEffect(() => {
    getPrices();
  }, []);

  return (
    <section className="mb-16">
      <h2 className="text-2xl font-bold mb-6">Select Pricing Option</h2>
      {loadingPrices ? (
        <div className="flex justify-center items-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        </div>
      ) : priceError ? (
        <div className="p-4 rounded-xl border border-destructive bg-destructive/40 mb-4 text-destructive-foreground">
          {priceError}
        </div>
      ) : !prices.length ? (
        <div className="text-center p-12 border rounded-lg">
          <h3 className="text-lg font-medium">No pricing options available</h3>
          <p className="text-muted-foreground mt-2">
            Please contact support for assistance
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {prices.map((price) => (
            <PriceCard
              key={price.id}
              price={price}
              isSelected={selectedPrice?.id === price.id}
              onSelect={() => setSelectedPrice(price)}
            />
          ))}
        </div>
      )}

      <div className="mt-4 flex items-center justify-between gap-2 flex-wrap">
        <Button
          variant="outline"
          onClick={() => setCurrentStep(1)}
          className="w-full sm:w-fit"
        >
          Back to Teachers
        </Button>
        <Button
          disabled={!selectedPrice}
          onClick={() => setCurrentStep(3)}
          className="w-full sm:w-fit"
        >
          Continue to Time Selection
        </Button>
      </div>
    </section>
  );
}
